// src/screens/WaiverScreen.js
// The waiver is now accepted on the booking page itself (every booking, text
// from the server). Old links to /vehicle/:id/waiver go there.
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const WaiverScreen = () => {
  const { id } = useParams();
  return <Navigate to={`/vehicle/${id}/appointment`} replace />;
};

export default WaiverScreen;
